import type { ReactNode } from 'react';

/**
 * 데모 페이지 상단에 What / Why 두 단락을 보여주는 카드.
 * 처음 보는 사용자가 페이지의 의도를 즉시 파악하도록 항상 펼쳐진 상태로 둔다.
 */
export function InfoPanel({ what, why }: { what: ReactNode; why: ReactNode }) {
  return (
    <div className="card">
      <h3 style={{ marginTop: 0 }}>What</h3>
      <div>{what}</div>
      <h3 style={{ marginTop: '1rem' }}>Why</h3>
      <div>{why}</div>
    </div>
  );
}
